import { createContext } from "react";
import { ActivePosition } from "src/types/products";

export interface Actions {
	onCollapse: () => void;
}

export interface ContextType {
	isCollapsed?: boolean;
	positions: ActivePosition[];
	actions: Actions;
}

const defaultContextValues: ContextType = {
	isCollapsed: false,
	positions: [],
	actions: {
		onCollapse: () => {}
	}
};

export default createContext<ContextType>(defaultContextValues);
